/* src/app/shared/color-picker/color-picker.component.scss */
.labelButton {
  width: 100%;
}
.colorButton {
  --border-radius: 100%;
  width: 10vw;
  height: 10vw;
  padding: 1vw;
}
.accordion-collapsed > ion-item > .labelButton {
  --border-radius: 100%;
  width: 10vw;
  height: 10vw;
  padding: 1vw;
}
/*# sourceMappingURL=color-picker.component.css.map */
